import duplicateMid from './duplicateMid';
import detailDuplicateMid from './detailDuplicateMid';

const mid = {
  namespaced: true,

  modules: {
    duplicateMid,
    detailDuplicateMid,
  },
};
export default mid;
